export default function Empty() {
  return {}
}
